import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getLocationsByPlant } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to access locations.
 * @param {boolean} [active] - Filter for active plants
 * @param {string} [plant] - Optional plant filter
 */
export const useLocations = (active, plant) => {
  const { apiReady } = useApiReady();
  const { selectedPlant } = useAppContext();

  const effectivePlant = plant || selectedPlant;

  return useQuery({
    queryKey: [QUERY_KEYS.LOCATION_DATA, effectivePlant, { active }],
    queryFn: async () => {
      const locations = await getLocationsByPlant(effectivePlant, active ? { active } : undefined);

      return locations;
    },
    staleTime: Infinity,
    enabled: Boolean(apiReady && effectivePlant),
  });
};
